import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './app/App';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

/** Known deploy / gateway bases. Longest match wins. Local (no prefix) uses "". */
const KNOWN_BASES = ["/chatbots", process.env.REACT_APP_BASENAME];

function resolveBasename() {
  const pathname = window.location.pathname;
  const match = [...KNOWN_BASES]
    .filter(Boolean)
    .sort((a, b) => b.length - a.length)
    .find((base) => pathname === base || pathname.startsWith(`${base}/`));
  return match || process.env.REACT_APP_BASENAME || "";
}

const basename = resolveBasename();

root.render(
  <Provider store={store} >
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter >
  </Provider>
);
